// Helpers para identificar al consumidor final. Modulo sin dependencias para
// poder importarse desde salesReceivables.js y clientBalances.js sin generar
// imports circulares.

export function isConsumidorFinalTaxCondition(client) {
  const normalizedTax = String(client?.tax_condition || "").toLowerCase();
  const normalizedName = String(client?.full_name || "").toLowerCase();
  return normalizedTax.includes("consumidor final") || normalizedName === "consumidor final";
}

// Identifica al cliente generico/anonimo "Consumidor Final" (venta de mostrador)
// SOLO por nombre. No alcanza a clientes con nombre propio cuya condicion fiscal
// sea Consumidor Final, que si pueden operar a cuenta corriente.
export function isGenericConsumidorFinalClient(client) {
  return String(client?.full_name || "").trim().toLowerCase() === "consumidor final";
}
